<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">{{ pageTitle }}</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>
    <div class="p-3">
      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>
      
      <div v-else-if="content" class="content-wrapper bg_white rounded-4 shadow_box p-4">
         <div v-html="content" class="html-content"></div>
      </div>

      <div v-else class="text-center mt-5 text_color_gray">
        محتوایی برای نمایش وجود ندارد.
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'InfoView',
  props: {
    pageType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      content: '',
      currentPageType: ''
    }
  },
  computed: {
    pageTitle() {
      if (this.currentPageType === 'about_us') {
        return 'درباره ما'
      }
      if (this.currentPageType === 'rules') {
        return 'شرایط و قوانین'
      }
      if (this.currentPageType === 'teacher_rules') {
        return 'قوانین و مقررات استاد'
      }
      return 'اطلاعات'
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.currentPageType = this.pageType || this.$route.params.pageType
    if (this.currentPageType) {
      this.fetchInfo()
    }
  },
  methods: {
    async fetchInfo() {
      this.loading = true
      this.content = ''
      
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          action: this.currentPageType,
          user_id: userId
        })
        
        const response = await apiClient.post('/public_info', formData)
        
        if (typeof response.data === 'string') {
          this.content = response.data
        } 
        else if (response.data.status === true || response.data.status === 'ok') {
          const rawData = response.data.data
          const processedData = (typeof rawData === 'string' && !rawData.startsWith('<')) 
                                ? Decryption(rawData) 
                                : rawData
          
          if (processedData) {
             this.content = (typeof processedData === 'object' && processedData.value) 
                            ? processedData.value 
                            : processedData
          }
        }
        else if (response.data) {
           this.content = response.data
        }

      } catch (error) {
        console.error(`Error fetching ${this.currentPageType}:`, error)
        this.content = 'مشکل در برقراری ارتباط با سرور.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.content-wrapper {
  overflow-x: hidden;
}

:deep(.html-content),
:deep(.html-content *) {
  color: #333333 !important;
  font-family: inherit !important;
  line-height: 1.8 !important;
  font-size: 1.35rem;
  background-color: transparent !important;
}
</style>